<template>
  <div class="chart-condition">
    <div v-if="false"
         class="expect">预计剩余油量还可继续行驶：
      <span class="expect-day">3天（约400nm）</span>
    </div>
    <!-- v-if="isShowInfo" -->
    <!-- 提示信息暂不显示 -->
    <div v-if="false"
         class="info">
      <div class="info-text">
        <el-icon color="#f95b5b">
          <WarningFilled />
        </el-icon>
        <div>
          <div class="tips"
               v-if="stockData!=''">{{stockData}}</div>
          <div class="tips"
               v-if="expendData!=''">{{expendData}}</div>
        </div>

        <!-- <span>×</span> -->
      </div>
      <el-icon style="cursor: pointer;"
               @click="isShowInfo=false">
        <CloseBold />
      </el-icon>
    </div>
    <div id="liquidChart">
    </div>
    <div id="liquidChart2">
    </div>
  </div>
</template>
<script>
import * as echarts from "echarts";
import { toRaw } from "@vue/reactivity";
import "echarts-liquidfill";
import { WarningFilled, CloseBold } from "@element-plus/icons-vue";
export default {
  data() {
    return {
      isShowInfo: false, //是否展示提示
      infoData: "", //提示
      stockData: "", //存量提示语
      expendData: "", //消耗提示语
      // 水球数据
      sphereData: [
        {
          value: 0,
          name: "重油存量",
          num: 0,
          isNull: true,
        },
        {
          value: 0,
          name: "轻油存量",
          num: 0,
          isNull: true,
        },
        {
          value: 0,
          name: "淡水存量",
          num: 0,
          isNull: true,
        },
      ],
      // 柱状图数据
      barData: [
        {
          value: 0,
          isNull: true,
        },
        {
          value: 0,
          isNull: true,
        },
        {
          value: 0,
          isNull: true,
        },
      ],
      myChart: null,
      sphereOption: {}, //球体echarts
      barOption: {}, //柱状图echarts
      sphereColorList: ["#ec2f44", "#019fe7"], //水球边框颜色(红、蓝)
      sphereWaterColorList: [
        // 红色
        {
          type: "linear",
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              offset: 0,
              color: "rgba(235, 127, 140, 0.32)",
            },
            {
              offset: 1,
              color: "rgba(235, 127, 140, 0.82)",
            },
          ],
        },
        // 蓝色
        {
          type: "linear",
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              offset: 0,
              color: "rgba(128, 210, 247, 0.32)",
            },
            {
              offset: 1,
              color: "rgba(128, 210, 247, 0.82)",
            },
          ],
        },
      ], //水球水体颜色
    };
  },
  props: {
    clientWidth: {
      type: Number,
      default: () => {
        return null;
      },
    },
    oilInfo: {
      type: Object,
      default: () => {
        return null;
      },
    },
    changeWidth: {
      type: Boolean,
      default: () => {
        return null;
      },
    },
  },
  computed: {},
  watch: {
    oilInfo(newV) {
      this.updateOilInfo(newV)
    },
    changeWidth(newV) {
      if (newV) {
        this.resizeCharts();
      }
    },
  },
  components: {
    WarningFilled,
    CloseBold,
  },
  methods: {
    // 存量信息改变
    changeStock(value) {
      if (this.stockData != "") {
        this.stockData = this.stockData + " " + value;
      } else {
        this.stockData = this.stockData + value;
      }
    },
    // 消耗信息改变
    changeExpend(value) {
      if (this.expendData != "") {
        this.expendData = this.expendData + " " + value;
      } else {
        this.expendData = this.expendData + value;
      }
    },
    // 获取图表数据
    updateOilInfo(value) {
      this.isShowInfo = false;
      let sphereData = [];
      let barData = [];
      this.stockData = "";
      this.expendData = "";
      let obj = toRaw(value);
      for (let i in obj) {
        let condition = {};
        switch (i) {
          case "heavy_oil_stock":
            if (obj[i] || obj[i] == 0) {
              if (obj[i] < 100) {
                this.changeStock("重油");
              }
              condition = {
                value: parseFloat(obj[i] / obj.heavy_oil_tank_capacity).toFixed(
                  2
                ),
                name: "重油存量",
                num: obj[i].toFixed(2),
                isNull: false,
              };
            } else {
              condition = {
                value: 0,
                name: "重油存量",
                num: 0,
                isNull: true,
              };
            }
            sphereData.push(condition);
            break;
          case "light_oil_stock":
            if (obj[i]) {
              if (obj[i] < 100 || obj[i] == 0) {
                this.changeStock("轻油");
              }
              condition = {
                value: parseFloat(obj[i] / obj.light_oil_tank_capacity).toFixed(
                  2
                ),
                name: "轻油存量",
                num: obj[i].toFixed(2),
                isNull: false,
              };
            } else {
              condition = {
                value: 0,
                name: "轻油存量",
                num: 0,
                isNull: true,
              };
            }
            sphereData.push(condition);
            break;
          case "water_stock":
            if (obj[i]) {
              if (obj[i] < 100 || obj[i] == 0) {
                this.changeStock("淡水");
              }
              condition = {
                value: parseFloat(
                  obj[i] / obj.freshwater_tank_capacity
                ).toFixed(2),
                name: "淡水存量",
                num: obj[i].toFixed(2),
                isNull: false,
              };
            } else {
              condition = {
                value: 0,
                name: "淡水存量",
                num: 0,
                isNull: true,
              };
            }
            sphereData.push(condition);
            break;
          case "heavy_oil_consume":
            if (obj[i] || obj[i] == 0) {
              if (obj[i] > 30) {
                this.changeExpend("重油");
              }
              condition = {
                value: obj[i].toFixed(2),
                isNull: false,
                itemStyle: {
                  color: obj[i] > 30 ? "#e14b4b" : "#02adf5",
                },
              };
            } else {
              condition = {
                value: 0,
                isNull: true,
                itemStyle: {
                  color: "#ec2f44",
                },
              };
            }
            barData.push(condition);
            break;
          case "light_oil_consume":
            if (obj[i] || obj[i] == 0) {
              if (obj[i] > 30) {
                this.changeExpend("轻油");
              }
              condition = {
                value: obj[i].toFixed(2),
                isNull: false,
                itemStyle: {
                  color: obj[i] > 30 ? "#e14b4b" : "#02adf5",
                },
              };
            } else {
              condition = {
                value: 0,
                isNull: true,
                itemStyle: {
                  color: "#ec2f44",
                },
              };
            }
            barData.push(condition);
            break;
          case "water_consume":
            if (obj[i] || obj[i] == 0) {
              if (obj[i] > 30) {
                this.changeExpend("淡水");
              }
              condition = {
                value: obj[i].toFixed(2),
                isNull: false,
                itemStyle: {
                  color: obj[i] > 30 ? "#e14b4b" : "#02adf5",
                },
              };
            } else {
              condition = {
                value: 0,
                isNull: true,
                itemStyle: {
                  color: "#ec2f44",
                },
              };
            }
            barData.push(condition);
            break;
          default:
            break;
        }
      }
      if (this.stockData != "") {
        this.isShowInfo = true;
        this.stockData = this.stockData + "存量过低！";
      }
      if (this.expendData != "") {
        this.isShowInfo = true;
        this.expendData = this.expendData + "消耗过高！";
      }
      // console.log(sphereData, barData);
      this.sphereData = sphereData;
      this.barData = barData;
      this.initData();
    },
    // 处理图表
    initChart(data, chart) {
      data && chart.setOption(data);
    },

    resizeCharts() {
      if (this.myChart) {
        this.myChart.resize();
      }
      if (this.myChart2) {
        this.myChart2.resize();
      }
    },
    // 存入数据
    initData() {
      if (this.myChart) {
        this.myChart.dispose();
      }
      if (this.myChart2) {
        this.myChart2.dispose();
      }
      var chartDom = document.getElementById("liquidChart");
      this.myChart = echarts.init(chartDom);
      var chartDom2 = document.getElementById("liquidChart2");
      this.myChart2 = echarts.init(chartDom2);
      // this.handlerData();
      if (this.clientWidth <= 1921) {
        this.initDataUnder1920();
        // console.log("ccc");
      } else if (this.clientWidth > 1921 && this.clientWidth <= 2560) {
        this.initDataUnder2560();
      } else {
        this.initDataUp4368();
      }

      this.initChart(this.sphereOption, this.myChart);
      this.initChart(this.barOption, this.myChart2);
    },
    // 完成series数据存储
    handlerData() {},
    initDataUnder1920() {
      let series = [];
      this.sphereData.forEach((item, index) => {
        let color = "";
        let color2 = {};
        if (Number(item.value) <= 0.1) {
          color = this.sphereColorList[0];
          color2 = this.sphereWaterColorList[0];
        } else {
          color = this.sphereColorList[1];
          color2 = this.sphereWaterColorList[1];
        }
        series.push({
          type: "liquidFill",
          name: item.name,
          radius: "65%",
          center: [`${25 * (index + 1)}%`, "50%"],

          //  shape: 'roundRect',
          data: [item.value, item.value, item.value],
          backgroundStyle: {
            color: "transparent",
          },
          amplitude: 2,
          color: [color2],
          itemStyle: {
            opacity: 0.6,
          },
          outline: {
            borderDistance: 2,
            itemStyle: {
              borderWidth: 2,
              borderColor: color,
              shadowBlur: 10,
              shadowColor: "#000",
            },
          },
          label: {
            position: ["50%", "50%"],
            formatter: function () {
              if (item.isNull) {
                return `\n${item.name}\n\n--`;
              }
              return `\n${item.name}\n\n${item.num}吨`;
            },
            fontSize: 11,
            fontWeight: 300,
            color: "#fff",
          },
        });
      });
      this.sphereOption = {
        series: series,
        // tooltip: {
        //   trigger: "item", // 触发类型, 数据项图形触发，主要在散点图，饼图等无类目轴的图表中使用。
        //   textStyle: {
        //     color: "#fff", // 文字颜色
        //     fontSize: 10,
        //   },
        //   backgroundColor: "#061f3cd9",

        //   // 提示框浮层内容格式器，支持字符串模板和回调函数两种形式
        //   // 水球图: {a}（系列名称），{b}（无），{c}（数值）
        //   // 使用函数模板   传入的数据值 -> value: number|Array,
        //   formatter: function (value) {
        //     // console.log(value);
        //     return (
        //       value.seriesName +
        //       ": " +
        //       parseFloat(value.data * 100).toFixed(0) +
        //       "%"
        //     );
        //   },
        // },
      };
      this.barOption = {
        // color: ["#02a7ef"],
        grid: {
          top: "25%",
          bottom: "25%",
        },
        xAxis: {
          type: "category",
          data: ["重油消耗", "轻油消耗", "淡水消耗"],
          axisTick: {
            show: false, //是否显示网状线 默认为true
          },
          axisLabel: {
            textStyle: {
              //textStyle里面写x轴下的字体的样式
              color: "#fff",
              fontSize: 11,
            },
          },
          axisLine: {
            show: true, //这里的show用于设置是否显示x轴那一条线 默认为true
            lineStyle: {
              //lineStyle里面写x轴那一条线的样式
              color: "#fff",
              width: 1, //轴线的粗细 我写的是2 最小为0，值为0的时候线隐藏
            },
          },
        },
        yAxis: {
          type: "value",
          splitLine: { show: false }, //去除网状线 默认为true
          //用于设置y轴的字体
          axisLabel: {
            show: false, //这里的show用于设置是否显示y轴下的字体 默认为true
          },
          //用于设置y轴的那一条线
          axisLine: {
            show: false, //这里的show用于设置是否显示y轴那一条线 默认为true
          },
        },
        series: [
          {
            data: this.barData,
            type: "bar",
            label: {
              show: true,
              position: "top",
              formatter: function (params) {
                if (params.data.isNull == true) {
                  return "--";
                }
                return Number(params.data.value).toFixed(2) + "吨";
              },
              color: "inherit",
              fontSize: 11,
              borderType: 0,
            },
            barWidth: 20, //柱图宽度,
          },
        ],
      };
      // console.log(series, this.sphereOption, this.barOption);
    },
    initDataUnder2560() {
      let series = [];
      this.sphereData.forEach((item, index) => {
        let color = "";
        let color2 = {};
        if (Number(item.value) <= 0.1) {
          color = this.sphereColorList[0];
          color2 = this.sphereWaterColorList[0];
        } else {
          color = this.sphereColorList[1];
          color2 = this.sphereWaterColorList[1];
        }
        series.push({
          type: "liquidFill",
          name: item.name,
          radius: "65%",
          center: [`${25 * (index + 1)}%`, "50%"],

          //  shape: 'roundRect',
          data: [item.value, item.value, item.value],
          backgroundStyle: {
            color: "transparent",
          },
          amplitude: 2,
          color: [color2],
          itemStyle: {
            opacity: 0.6,
          },
          outline: {
            borderDistance: 2,
            itemStyle: {
              borderWidth: 2,
              borderColor: color,
              shadowBlur: 10,
              shadowColor: "#000",
            },
          },
          label: {
            position: ["50%", "50%"],
            formatter: function () {
              if (item.isNull) {
                return `\n${item.name}\n\n--`;
              }
              return `\n${item.name}\n\n${item.num}吨`;
            },
            fontSize: 20,
            fontWeight: 300,
            color: "#fff",
          },
        });
      });
      this.sphereOption = {
        series: series,
      };
      this.barOption = {
        color: ["#02a7ef"],
        grid: {
          top: "25%",
          bottom: "25%",
        },
        xAxis: {
          type: "category",
          data: ["重油消耗", "轻油消耗", "淡水消耗"],
          axisTick: {
            show: false, //是否显示网状线 默认为true
          },
          axisLabel: {
            textStyle: {
              //textStyle里面写x轴下的字体的样式
              color: "#fff",
              fontSize: 20,
            },
          },
          axisLine: {
            show: true, //这里的show用于设置是否显示x轴那一条线 默认为true
            lineStyle: {
              //lineStyle里面写x轴那一条线的样式
              color: "#fff",
              width: 1, //轴线的粗细 我写的是2 最小为0，值为0的时候线隐藏
            },
          },
        },
        yAxis: {
          type: "value",
          splitLine: { show: false }, //去除网状线 默认为true
          //用于设置y轴的字体
          axisLabel: {
            show: false, //这里的show用于设置是否显示y轴下的字体 默认为true
          },
          //用于设置y轴的那一条线
          axisLine: {
            show: false, //这里的show用于设置是否显示y轴那一条线 默认为true
          },
        },
        series: [
          {
            data: this.barData,
            type: "bar",
            label: {
              show: true,
              position: "top",
              formatter: function (params) {
                if (params.data.isNull == true) {
                  return "--";
                }
                return params.data.value + "吨";
              },
              color: "inherit",
              fontSize: 20,
            },
            barWidth: 25, //柱图宽度,
          },
        ],
      };
    },
    initDataUp4368() {
      let series = [];
      this.sphereData.forEach((item, index) => {
        let color = "";
        let color2 = {};
        if (Number(item.value) <= 0.1) {
          color = this.sphereColorList[0];
          color2 = this.sphereWaterColorList[0];
        } else {
          color = this.sphereColorList[1];
          color2 = this.sphereWaterColorList[1];
        }
        series.push({
          type: "liquidFill",
          name: item.name,
          radius: "65%",
          center: [`${25 * (index + 1)}%`, "50%"],

          //  shape: 'roundRect',
          data: [item.value, item.value, item.value],
          backgroundStyle: {
            color: "transparent",
          },
          amplitude: 2,
          color: [color2],
          itemStyle: {
            opacity: 0.6,
          },
          outline: {
            borderDistance: 5,
            itemStyle: {
              borderWidth: 2,
              borderColor: color,
              shadowBlur: 10,
              shadowColor: "#000",
            },
          },
          label: {
            position: ["50%", "50%"],
            formatter: function () {
              if (item.isNull) {
                return `\n${item.name}\n\n--`;
              }
              return `\n${item.name}\n\n${item.num}吨`;
            },
            fontSize: 20,
            fontWeight: 300,
            color: "#fff",
          },
        });
      });
      this.sphereOption = {
        series: series,
      };
      this.barOption = {
        color: ["#02a7ef"],
        grid: {
          top: "25%",
          bottom: "25%",
        },
        xAxis: {
          type: "category",
          data: ["重油消耗", "轻油消耗", "淡水消耗"],
          axisTick: {
            show: false, //是否显示网状线 默认为true
          },
          axisLabel: {
            textStyle: {
              //textStyle里面写x轴下的字体的样式
              color: "#fff",
              fontSize: 24,
            },
          },
          axisLine: {
            show: true, //这里的show用于设置是否显示x轴那一条线 默认为true
            lineStyle: {
              //lineStyle里面写x轴那一条线的样式
              color: "#fff",
              width: 1, //轴线的粗细 我写的是2 最小为0，值为0的时候线隐藏
            },
          },
        },
        yAxis: {
          type: "value",
          splitLine: { show: false }, //去除网状线 默认为true
          //用于设置y轴的字体
          axisLabel: {
            show: false, //这里的show用于设置是否显示y轴下的字体 默认为true
          },
          //用于设置y轴的那一条线
          axisLine: {
            show: false, //这里的show用于设置是否显示y轴那一条线 默认为true
          },
        },
        series: [
          {
            data: this.barData,
            type: "bar",
            label: {
              show: true,
              position: "top",
              formatter: function (params) {
                if (params.data.isNull == true) {
                  return "--";
                }
                return params.data.value + "吨";
              },
              color: "inherit",
              fontSize: 24,
            },
            barWidth: 30, //柱图宽度,
          },
        ],
      };
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.updateOilInfo(this.oilInfo)
    })
  },
  beforeUnmount() {
    if (this.myChart) {
      this.myChart.dispose();
    }
    if (this.myChart2) {
      this.myChart2.dispose();
    }
  }
};
</script>
<style lang="scss" scoped>
.chart-condition {
  width: 90% !important;
  height: 100%;
  margin: 0 auto !important;
  display: flex !important;
  flex-direction: column !important;
  #liquidChart {
    width: 100%;
    height: 50%;
  }
  #liquidChart2 {
    width: 100%;
    height: 50%;
  }
  // .expect {
  //   width: 100%;
  //   height: 10%;
  //   font-size: 14px;
  //   .expect-day {
  //     color: #d22e44;
  //     font-weight: 800;
  //     font-size: 12px;
  //   }
  // }
  // .info {
  //   background-color: #d22e4456;
  //   display: flex;
  //   justify-content: space-between;
  //   width: 60%;
  //   border-radius: 3px;
  //   padding: 3px;
  //   position: absolute;
  //   right: 3%;
  //   top: calc(31.5vh);
  //   .info-text {
  //     color: white;
  //     font-size: 12px;
  //     display: flex;
  //     align-items: center;
  //     i {
  //       font-size: 14px;
  //       margin-right: 3px;
  //     }
  //   }
  // }
}
@media screen and (max-width: 1920px) {
  .expect {
    width: 100%;
    height: 10%;
    font-size: 14px;
    .expect-day {
      color: #d22e44;
      font-weight: 800;
      font-size: 12px;
    }
  }
  .info {
    background-color: #d22e4456;
    display: flex;
    justify-content: space-between;
    width: 60%;
    border-radius: 3px;
    padding: 3px;
    position: absolute;
    right: 3%;
    top: calc(31.5vh);
    .info-text {
      color: white;
      font-size: 12px;
      display: flex;
      align-items: center;
      i {
        font-size: 14px;
        margin-right: 3px;
      }
    }
  }
  .tips {
    font-size: 10px;
  }
}
@media screen and (min-width: 1921px) {
  .expect {
    width: 100%;
    height: 10%;
    font-size: 14px;
    .expect-day {
      color: #d22e44;
      font-weight: 800;
      font-size: 12px;
    }
  }
  .info {
    background-color: #d22e4456;
    display: flex;
    justify-content: space-between;
    width: 60%;
    border-radius: 3px;
    padding: 3px;
    position: absolute;
    right: 3%;
    top: calc(31.5vh);
    .info-text {
      color: white;
      font-size: 12px;
      display: flex;
      align-items: center;
      i {
        font-size: 14px;
        margin-right: 3px;
      }
    }
  }
  .tips {
    font-size: 20px;
  }
}

@media screen and (min-width: 2560px) {
  .expect {
    width: 100%;
    height: 10%;
    font-size: 26px;
    .expect-day {
      color: #d22e44;
      font-weight: 800;
      font-size: 24px;
    }
  }
  .info {
    background-color: #d22e4456;
    display: flex;
    justify-content: space-between;
    width: 60%;
    border-radius: 3px;
    padding: 3px;
    position: absolute;
    right: 3%;
    top: calc(1.5vh);
    .info-text {
      color: white;
      font-size: 24px;
      display: flex;
      align-items: center;
      i {
        font-size: 26px;
        margin-right: 3px;
      }
    }
  }
  .tips {
    font-size: 24px;
  }
}

@media screen and (min-width: 4360px) {
  .expect {
    width: 100%;
    height: 10%;
    font-size: 32px;
    .expect-day {
      color: #d22e44;
      font-weight: 800;
      font-size: 30px;
    }
  }
  .info {
    background-color: #d22e4456;
    display: flex;
    justify-content: space-between;
    width: 60%;
    border-radius: 3px;
    padding: 3px;
    position: absolute;
    right: 3%;
    top: calc(1.5vh);
    .info-text {
      color: white;
      font-size: 30px;
      display: flex;
      align-items: center;
      i {
        font-size: 32px;
        margin-right: 3px;
      }
    }
  }
  .tips {
    font-size: 30px;
  }
}
@media screen and (min-width: 6720px) {
  .expect {
    width: 100%;
    height: 10%;
    font-size: 42px;
    .expect-day {
      color: #d22e44;
      font-weight: 800;
      font-size: 40px;
    }
  }
  .info {
    background-color: #d22e4456;
    display: flex;
    justify-content: space-between;
    width: 60%;
    border-radius: 3px;
    padding: 3px;
    position: absolute;
    right: 3%;
    top: calc(1.5vh);
    .info-text {
      color: white;
      font-size: 40px;
      display: flex;
      align-items: center;
      i {
        font-size: 42px;
        margin-right: 3px;
      }
    }
  }
  .tips {
    font-size: 40px;
  }
}
</style>

